import React, {useState} from 'react'
import useTranslate from 'modules/local/useTranslate'
import {PiLockKeyFill} from "react-icons/pi";
import classNames from "classnames";
import {GoDotFill} from "react-icons/go";
import {TbEdit, TbTrash} from "react-icons/tb";

const RoleItem = ({isLg, item, onEdit, onDelete}) => {
    const t = useTranslate()
    const isSystem = !!item.is_system
    const [hovered, setHovered] = useState(false)

    return (
        <div
            className="p-4 flex items-center transition-colors list-item"
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}>
            <div className="flex items-center flex-1 gap-3">
                {isSystem
                    ? <PiLockKeyFill size={22} className="text-secondary"/>
                    : (
                        <GoDotFill
                            size={16}
                            className={classNames('flex', item?.active ? 'text-green-500' : 'text-gray-300',)}
                        />
                    )
                }
                <div className="flex flex-col flex-1 min-w-0">
                    <div className="font-bold text-gray-700 text-base tracking-wide">
                        {item.name}
                    </div>
                    <div className="text-color-300 tracking-wider">
                        {isSystem
                            ? t(item?.role_description)
                            : item?.active
                                ? t('active')
                                : t('inactive')}
                    </div>
                </div>
            </div>

            {!isSystem && (
                <div
                    className="flex items-center gap-6 flex-shrink-0 transition-colors duration-300"
                    style={{opacity: hovered ? 1 : 0.5}}>
                    <button
                        onClick={() => onEdit && onEdit(item)}
                        className="flex items-center gap-1 text-gray-500 hover:text-blue-600">
                        <TbEdit size={15}/>
                        {isLg && t('edit')}
                    </button>
                    <button
                        onClick={() => onDelete && onDelete(item)}
                        className="flex items-center gap-1 text-gray-500 hover:text-primary-500">
                        <TbTrash size={16}/>
                        {isLg && t('delete')}
                    </button>
                </div>
            )}
        </div>
    )
}

export default RoleItem